function buildHierarchy(data) {
    data.each(function() {
        var $table = $('<tr>\n' +
            '    <td class="box">\n' +
            data.condition +
            '    </td>\n' +
            '  </tr>');
        var $pipe = $('<tr>\n' +
            '    <td class="connector">\n' +
            '\n' +
            '    </td>\n' +
            '  </tr>');
        $('.fabricator-content').append($(table).append($pipe));
    });

}